<template>
  <section class="layout-container" :id="info.id">
    <!-- 编辑模式 -->
    <template v-if="isEditMode">
      <img
        class="picture editMode"
        :src="
          info.src +
          '&imageMogr2/thumbnail/2000x3000/format/' +
          $pic_type +
          '/interlace/1'
        "
        :style="info.style"
      />
    </template>

    <!-- 渲染模式 -->
    <template v-else>
      <img
        class="picture forbid"
        @click="link()"
        :src="
          info.src +
          '&imageMogr2/thumbnail/2000x3000/format/' +
          `${info.src.toLowerCase().indexOf('gif') < 0 ? $pic_type : 'gif'}` +
          '/interlace/1'
        "
        :style="info.style"
      />
    </template>
  </section>
</template>
<script>
import api from '@/Api.js'
export default {
  /******************************************
  ** 图片组件
  * @description 图片组件
  * @author stone
  *****************************************
  info            Object             属性样式数据
  isEditMode      Boolean            是否编辑模式
  *****************************************/
  name: 'textLayout',
  components: {},
  props: {
    info: {
      type: Object
    },
    isEditMode: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {}
  },
  computed: {},
  methods: {
    link () {
      if (this.info.link) {
        if (this.info.link.indexOf('https://') !== -1) {
          window.location.href = this.info.link
        } else {
          window.location.href = 'https://' + this.info.link
        }
      }
      if (this.info.linkMap) {
        const lat = this.info.linkMap.split(',')[0]
        const lng = this.info.linkMap.split(',')[1]
        const _this = this
        /* eslint-disable */
        api.jsapiSignature(window.location.href).then((res) => {
          // 初始化页面信息
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.AppId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: res.data.Timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.NonceString, // 必填，生成签名的随机串
            signature: res.data.Signature, // 必填，签名，见附录1
            jsApiList: [
              'checkJsApi',
              'updateTimelineShareData',
              'updateAppMessageShareData',
              'openLocation',
              'getLocation'
            ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
          wx.ready(function () {
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            wx.openLocation({
              latitude: parseFloat(lat), // 纬度，浮点数，范围为90 ~ -90
              longitude: parseFloat(lng), // 经度，浮点数，范围为180 ~ -180。
              name: _this.info.mapName, // 位置名
              address: _this.info.mapName,
              scale: 15, // 地图缩放级别,整形值,范围从1~28。默认为最大
              infoUrl: 'https://www.aiyaopai.com' // 在查看位置界面底部显示的超链接,可点击跳转
            })
          })
        })
      }
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.layout-container {
  // border: 1px solid transparent;

  .picture {
    width: 100%;
    display: block;
    transform: scale3d(1, 1, 1);
  }
  .editMode {
    border: 1px solid transparent;
    box-sizing: border-box;
    &:hover {
      cursor: move;
      border: 1px solid #2354f2;
    }
  }
}
</style>
